import "./offer.css";
import Offer1 from "../../Images/offer1.jpeg";
import Offer2 from "../../Images/offer2.jpeg";
import Offer3 from "../../Images/offer3.jpeg";
import Offer4 from "../../Images/offer4.jpeg";
import Offer5 from "../../Images/offer5.jpeg";

const images = [Offer1, Offer2, Offer3, Offer4, Offer5];

export default function TopPlacementsGrid() {
  return (
    <div className="placements-container">
      <h2 className="placements-heading">Our Top Placements</h2>

      <div className="placements-row">
        {images.map((img, i) => (
          <div className="placements-card" key={i}>
            <img
              src={img}
              alt="placement"
              className="placements-card-img"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
